import { render, staticRenderFns } from "./br-select.vue?vue&type=template&id=28fa6b48"
import script from "./br-select.vue?vue&type=script&lang=js"
export * from "./br-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports